import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { shopStatus } from "./StoreLocatorShopSchedule";
const openSoonTime = 30;
const dayIndexFromMonday = {
    Monday: 0,
    Tuesday: 1,
    Wednesday: 2,
    Thursday: 3,
    Friday: 4,
    Saturday: 5,
    Sunday: 6,
};
export const getCurrentTimeInTimezone = (timeZone) => {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    return dayjs().tz(timeZone).format("YYYY-MM-DD HH:mm:ss");
};
export const getCurrentDayShopStatus = (currentDayShopSchedule, time_zone, isOpeningHoursBreaksEnabled, isListView, nextDayOpenTime) => {
    const { open_time, close_time, break_start_time, break_end_time } = currentDayShopSchedule;
    const now = new Date(getCurrentTimeInTimezone(time_zone)).getTime();
    const setTime = (timeStr) => {
        const [h, m] = timeStr.split(":").map(Number);
        return new Date().setHours(h, m, 0, 0);
    };
    const openTime = setTime(open_time);
    const breakStart = setTime(break_start_time);
    const breakEnd = setTime(break_end_time);
    const closeTime = setTime(close_time);
    const minutesUntil = (target) => (target - now) / (1000 * 60);
    if (isOpeningHoursBreaksEnabled && !isListView) {
        if (minutesUntil(breakEnd) > 0 && minutesUntil(breakEnd) <= openSoonTime) {
            return { shopOpeningStatus: shopStatus.open_soon, shopOpeningHours: break_end_time };
        }
        if (now >= openTime && now < breakStart) {
            return { shopOpeningStatus: shopStatus.open, shopOpeningHours: break_start_time };
        }
        if (now >= breakStart && now < breakEnd) {
            return { shopOpeningStatus: shopStatus.closed, shopOpeningHours: break_end_time };
        }
    }
    if (minutesUntil(openTime) > 0) {
        if (minutesUntil(openTime) <= openSoonTime) {
            return { shopOpeningStatus: shopStatus.open_soon, shopOpeningHours: open_time };
        }
        return { shopOpeningStatus: shopStatus.closed, shopOpeningHours: open_time };
    }
    if (now >= openTime && now < closeTime) {
        return { shopOpeningStatus: shopStatus.open, shopOpeningHours: close_time };
    }
    return { shopOpeningStatus: shopStatus.closed, shopOpeningHours: nextDayOpenTime };
};
export const getDayOfWeekMondayFirst = () => {
    const dayName = dayjs().format("dddd");
    return dayIndexFromMonday[dayName];
};
export const getNextDayOpenTime = (weekSchedule) => {
    let dayIndex = getDayOfWeekMondayFirst();
    let attempts = 0;
    while (attempts < 7) {
        dayIndex = (dayIndex + 1) % 7;
        const day = weekSchedule[dayIndex];
        if (!day.closed && day.open_time) {
            return day.open_time;
        }
        attempts++;
    }
    return null;
};
//# sourceMappingURL=utils.js.map